import React, { useState, useEffect } from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import classnames from 'classnames';
import { MATERIAL_TRANSITION_TIME } from 'swag-client-common/constants';
import { removeSuperSpeedProductIdFromLS, setSuperSpeedProductIdInLS } from 'swag-client-common/utils/super-speed-local-storage.utils';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import { variables } from 'swag-client-common/styles/variables-js';
import Drawer from '../../ui/drawer';
import { getSuperSpeedProductionTimeWithIndex } from '../../../redux/product/product.utils';
import classes from './production-time-dialog.scss';
import { TimeTableWithEmbellishment } from './components/time-table-with-embelishment';
export const ProductionTimeDialog = ({
  open,
  prodTime,
  productId,
  isBox,
  embellishmentMethods,
  productSettings = [],
  prerenderForCrawlers = false,
  isLimitedEdition,
  isItemEditing,
  isSharedItem,
  popupParams,
  selectedEmbellishmentMethod,
  onUpdateItem,
  onSaveProductionTimeChanges,
  onSharedItemUpdate,
  onOpenConfirmPopup,
  changeEmbellishmentMethod,
  onClose,
  isOnCheckout = false,
  uniqueColorsForOrderItem,
  onShowSuperSpeedColorLimitationPopup,
  onShowEmbellishmentMethodChangeConfirmationPopup,
  currentEmbellishmentMethod,
  debossedEmbellishmentMethodId,
  hasDebossedPopupBeenShown
}) => {
  var _productSettings$;
  const [localProdTime, setLocalProdTime] = useState(-1);
  const [localEmbellishmentMethodId, setEmbellishmentMethodId] = useState(null);
  const [initialProdTime, setInitialProdTime] = useState(-1);
  useEffect(() => {
    if (open) {
      setLocalProdTime(prodTime);
      setInitialProdTime(prodTime);
    }
  }, [open, prodTime]);
  useEffect(() => {
    if (selectedEmbellishmentMethod !== null && selectedEmbellishmentMethod !== void 0 && selectedEmbellishmentMethod._id && selectedEmbellishmentMethod._id !== localEmbellishmentMethodId) {
      setEmbellishmentMethodId(selectedEmbellishmentMethod._id);
    }
  }, [selectedEmbellishmentMethod]);
  useEffect(() => {
    if (popupParams !== null && popupParams !== void 0 && popupParams.confirmedEmbellishmentMethodId && (popupParams === null || popupParams === void 0 ? void 0 : popupParams.confirmedEmbellishmentMethodId) !== localEmbellishmentMethodId) {
      setEmbellishmentMethodId(popupParams.confirmedEmbellishmentMethodId);
      setLocalProdTime(popupParams.confirmedProductionTimeIdx || 0);
    }
  }, [popupParams]);
  const onRequestClose = () => {
    onClose();
    setTimeout(() => {
      setLocalProdTime(-1);
      setInitialProdTime(-1);
    }, MATERIAL_TRANSITION_TIME);
  };
  const saveChanges = () => {
    var _productSettings$find, _currentProductSettin;
    const isSameEmbellishmentMethod = (currentEmbellishmentMethod === null || currentEmbellishmentMethod === void 0 ? void 0 : currentEmbellishmentMethod.embellishmentMethodId) === localEmbellishmentMethodId;
    const isSameTime = initialProdTime === localProdTime;
    const currentProductSettings = productSettings.find(setting => setting.embellishmentMethodId === localEmbellishmentMethodId);
    const currentProductionTimeList = (currentProductSettings === null || currentProductSettings === void 0 ? void 0 : currentProductSettings.productionTimeList) || [];
    const prevProductionTimeList = selectedEmbellishmentMethod ? ((_productSettings$find = productSettings.find(setting => setting.embellishmentMethodId === selectedEmbellishmentMethod._id)) === null || _productSettings$find === void 0 ? void 0 : _productSettings$find.productionTimeList) || [] : [];
    const currentSuperSpeedProdTime = getSuperSpeedProductionTimeWithIndex(currentProductionTimeList);
    const {
      index: currentSuperSpeedProdTimeIdx
    } = currentSuperSpeedProdTime;
    const prevSuperSpeedProdTimeIdx = getSuperSpeedProductionTimeWithIndex(prevProductionTimeList).index;
    const toSuperSpeed = localProdTime === currentSuperSpeedProdTimeIdx;
    const fromSuperSpeed = initialProdTime === prevSuperSpeedProdTimeIdx;
    const shouldOpenSuperSpeedConfirmPopup = isItemEditing && !isSharedItem && (toSuperSpeed || fromSuperSpeed);
    const embellishmentIndex = getEmbellishmentIndex(localEmbellishmentMethodId);
    if (isSameTime && isSameEmbellishmentMethod) {
      return onRequestClose();
    }
    const superSpeedProductMaxPrintColors = (currentProductSettings === null || currentProductSettings === void 0 ? void 0 : (_currentProductSettin = currentProductSettings.superSpeed) === null || _currentProductSettin === void 0 ? void 0 : _currentProductSettin.maxPrintColors) || 0;
    if (isItemEditing && toSuperSpeed && superSpeedProductMaxPrintColors < uniqueColorsForOrderItem) {
      onShowSuperSpeedColorLimitationPopup(superSpeedProductMaxPrintColors);
      setTimeout(() => {
        setLocalProdTime(-1);
        setInitialProdTime(-1);
      }, MATERIAL_TRANSITION_TIME);
      return;
    }
    if (shouldOpenSuperSpeedConfirmPopup) {
      var _embellishmentMethods;
      return onOpenConfirmPopup({
        toSuperSpeed,
        fromSuperSpeed,
        time: localProdTime,
        embellishmentMethodId: localEmbellishmentMethodId || '',
        prevPopupParams: popupParams,
        methodName: toSuperSpeed ? (_embellishmentMethods = embellishmentMethods[embellishmentIndex]) === null || _embellishmentMethods === void 0 ? void 0 : _embellishmentMethods.name : ''
      });
    }
    if (toSuperSpeed) {
      setSuperSpeedProductIdInLS(productId);
    } else if (fromSuperSpeed) {
      removeSuperSpeedProductIdFromLS();
    }
    changeEmbellishmentMethod(localEmbellishmentMethodId);
    onSaveProductionTimeChanges(localProdTime);
    const showDebossedPopup = !!isItemEditing && !hasDebossedPopupBeenShown && localEmbellishmentMethodId === debossedEmbellishmentMethodId;
    const updateParams = {
      prodTime: localProdTime,
      embellishmentMethodId: localEmbellishmentMethodId || '',
      showDebossedPopup,
      isOnCheckout
    };
    if (isSharedItem && onSharedItemUpdate) {
      return onSharedItemUpdate(updateParams);
    }
    if (isItemEditing) {
      onUpdateItem(updateParams);
    }
    onRequestClose();
  };
  const getEmbellishmentIndex = embellishmentMethodId => {
    return embellishmentMethods.findIndex(e => e._id === embellishmentMethodId);
  };
  const onChangeProductionTimeWithEmbellishment = (embellishmentMethodId, productionTimeId) => {
    if (isItemEditing) {
      const confirmationAlreadyShown = (popupParams === null || popupParams === void 0 ? void 0 : popupParams.confirmedEmbellishmentMethodId) === embellishmentMethodId;
      const isSameMethod = embellishmentMethodId === (selectedEmbellishmentMethod === null || selectedEmbellishmentMethod === void 0 ? void 0 : selectedEmbellishmentMethod._id);
      const shouldShowConfirmationPopup = embellishmentMethodId && !confirmationAlreadyShown && !isSameMethod;
      if (shouldShowConfirmationPopup) {
        onShowEmbellishmentMethodChangeConfirmationPopup === null || onShowEmbellishmentMethodChangeConfirmationPopup === void 0 ? void 0 : onShowEmbellishmentMethodChangeConfirmationPopup({
          itemId: productId,
          embellishmentMethodId,
          isItemEdit: isItemEditing,
          productionTimeId,
          storageType: popupParams === null || popupParams === void 0 ? void 0 : popupParams.storageType
        });
        return;
      }
    }
    setEmbellishmentMethodId(embellishmentMethodId);
    setLocalProdTime(productionTimeId);
  };
  const haveFewProductionTimes = productSettings.length > 0 || ((_productSettings$ = productSettings[0]) === null || _productSettings$ === void 0 ? void 0 : _productSettings$.productionTimeList.length);
  return /*#__PURE__*/React.createElement(Drawer, {
    prerenderForCrawlers: prerenderForCrawlers,
    dataDrawer: "ProductionTime",
    open: open,
    onClose: onRequestClose,
    headerTitle: "Production Time",
    closeClassName: isLimitedEdition ? classes.orangeClose : '',
    bodyClassName: classes.postalWrapper,
    headerClassName: classes.postalHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.description
  }, "You will receive a production mockup within 2-3 business days after your colors are approved. The time to create the production mockup is already reflected in your estimated delivery date. After you approve your production mockup, we will start making your items!"), /*#__PURE__*/React.createElement(TimeTableWithEmbellishment, {
    isBox: !!isBox,
    selectedEmbellishmentMethod: localEmbellishmentMethodId,
    prodTime: localProdTime,
    editAvailable: true,
    onChange: onChangeProductionTimeWithEmbellishment,
    productSettings: productSettings,
    isLimitedEdition: !!isLimitedEdition,
    tableClassName: classes.tableClassName
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.warningBlock, {
      [classes.visible]: localEmbellishmentMethodId && localEmbellishmentMethodId !== (selectedEmbellishmentMethod === null || selectedEmbellishmentMethod === void 0 ? void 0 : selectedEmbellishmentMethod._id)
    })
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    classes: {
      root: classes.infoIcon
    },
    iconColor: isLimitedEdition ? variables.colorOrange : variables.colorPrimary
  }), /*#__PURE__*/React.createElement("p", {
    "data-text": "DecorationWarning"
  }, "Please note, your production time may change based on the decoration method you selected.")), /*#__PURE__*/React.createElement("div", {
    className: classes.confirmRow
  }, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: saveChanges,
    className: classnames(classes.confirmButton, {
      [classes.orangeBackground]: isLimitedEdition
    }),
    dataButton: "Confirm",
    withFocusOutline: true
  }, haveFewProductionTimes ? 'Confirm' : 'OK'))));
};